<template>
  <div class="container">
    <h1>包码 - 易生支付主扫支付</h1>
    
    <!-- 客户端信息显示区域 -->
    <div id="clientInfo" class="client-info" :class="clientInfoClass">
      {{ clientInfoText }}
    </div>
    
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="payType">支付类型:</label>
        <select id="payType" v-model="form.payType" required>
          <option value="AliPayNative">支付宝主扫</option>
          <option value="UnionPayNative">云闪付主扫</option>
          <option value="DcepNative">数币主扫</option>
        </select>
      </div>
      <div class="form-group">
        <label for="transAmount">交易金额(分):</label>
        <input type="number" id="transAmount" v-model.number="form.transAmount" min="1" required>
      </div>
      <div class="form-group">
        <label for="orderSub">订单标题:</label>
        <input type="text" id="orderSub" v-model="form.orderSub" required>
      </div>
      <button type="submit" id="submitBtn" :disabled="loading">
        {{ loading ? '生成中...' : '生成支付二维码' }}
      </button>
    </form>
    
    <div class="loading" v-if="loading">
      <div class="spinner"></div>
      <p>正在生成支付二维码...</p>
    </div>
    
    <div class="result" :class="resultClass" v-if="result.message">
      <strong>{{ result.type }}:</strong> {{ result.message }}
      <br><small v-if="result.respCode">响应码: {{ result.respCode }}</small>
    </div>
    
    <div class="qr-code-container" v-if="qrCodeUrl">
      <h3>请使用手机扫描以下二维码完成支付</h3>
      <div id="qrCode">
        <img :src="qrCodeImageUrl" alt="支付二维码" style="max-width: 200px; height: auto;">
        <p><small>二维码链接: <a :href="qrCodeUrl" target="_blank">{{ qrCodeUrl }}</a></small></p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'BaomaPayment',
  data() {
    return {
      form: {
        payType: 'AliPayNative',
        transAmount: 1,
        orderSub: '测试订单'
      },
      loading: false,
      result: {
        type: '',
        message: '',
        respCode: ''
      },
      qrCodeUrl: '',
      clientInfo: {
        type: '',
        text: '检测中...'
      }
    };
  },
  computed: {
    clientInfoClass() {
      switch(this.clientInfo.type) {
        case 'wechat': return 'wechat';
        case 'alipay': return 'alipay';
        default: return 'browser';
      }
    },
    clientInfoText() {
      return this.clientInfo.text;
    },
    resultClass() {
      return this.result.type === 'success' ? 'success' : 'error';
    },
    qrCodeImageUrl() {
      if (this.qrCodeUrl) {
        return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.qrCodeUrl)}`;
      }
      return '';
    }
  },
  mounted() {
    this.detectClient();
  },
  methods: {
    async detectClient() {
      try {
        const response = await api.get('/yisheng/detect-client');
        const clientType = response.data.clientType;
        this.updateClientInfo(clientType);
        this.updatePayTypeOptions(clientType);
      } catch (error) {
        console.error('后端客户端检测失败:', error);
        // 降级到前端检测
        const clientType = this.detectClientType();
        this.clientInfo = {
          type: clientType,
          text: '使用前端检测: ' + this.getClientTypeText(clientType)
        };
        this.updatePayTypeOptions(clientType);
      }
    },
    detectClientType() {
      const ua = window.navigator.userAgent.toLowerCase();
      
      if (ua.includes('micromessenger')) {
        return 'wechat';
      } else if (ua.includes('alipayclient')) {
        return 'alipay';
      } else {
        return 'browser';
      }
    },
    getClientTypeText(clientType) {
      switch(clientType) {
        case 'wechat': return '微信浏览器';
        case 'alipay': return '支付宝客户端';
        default: return '普通浏览器';
      }
    },
    updateClientInfo(clientType) {
      switch(clientType) {
        case 'wechat':
          this.clientInfo = {
            type: 'wechat',
            text: '检测到您正在使用微信浏览器'
          };
          break;
        case 'alipay':
          this.clientInfo = {
            type: 'alipay',
            text: '检测到您正在使用支付宝客户端'
          };
          break;
        default:
          this.clientInfo = {
            type: 'browser',
            text: '检测到您正在使用普通浏览器'
          };
      }
    },
    updatePayTypeOptions(clientType) {
      switch(clientType) {
        case 'alipay':
          this.form.payType = 'AliPayNative';
          break;
        default:
          // 保持默认选项
          break;
      }
    },
    async submitForm() {
      this.loading = true;
      this.result = { type: '', message: '', respCode: '' };
      this.qrCodeUrl = '';
      
      try {
        const response = await api.post('/yisheng/native-pay', this.form);
        const data = response.data;
        
        if (data.success) {
          this.result = {
            type: 'success',
            message: data.message,
            respCode: data.respCode
          };
          
          if (data.qrCodeUrl) {
            this.qrCodeUrl = data.qrCodeUrl;
          }
        } else {
          this.result = {
            type: 'error',
            message: data.message,
            respCode: data.respCode
          };
        }
      } catch (error) {
        console.error('请求失败:', error);
        this.result = {
          type: 'error',
          message: '网络错误: ' + error.message
        };
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
}
h1 {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
}
.form-group {
  margin-bottom: 20px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}
input, select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
}
button {
  width: 100%;
  padding: 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.3s;
}
button:hover {
  background-color: #45a049;
}
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.result {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
}
.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.loading {
  text-align: center;
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #4CAF50;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.qr-code-container {
  text-align: center;
  margin-top: 20px;
}
.client-info {
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.wechat {
  background-color: #c8e6c9;
  border-color: #4caf50;
  color: #2e7d32;
}
.alipay {
  background-color: #e1f5fe;
  border-color: #03a9f4;
  color: #0288d1;
}
.browser {
  background-color: #ffecb3;
  border-color: #ffc107;
  color: #ff9800;
}
</style>